import * as msal from '@azure/msal-browser';
import Avatar from '@material-ui/core/Avatar';
import {makeStyles} from '@material-ui/core/styles';
import {Client as GraphClient} from '@microsoft/microsoft-graph-client';
import React, {useEffect, useMemo, useState} from 'react';
import {useMsal} from '../Auth/Msal';

const useStyles = makeStyles(theme => ({
    avatar: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        fontSize: theme.typography.pxToRem(15),
    },
}));

type Props = {
    account : msal.AccountInfo;
};

const UserAvatar : React.FC<Props> = ({account} : Props) => {
    const msal = useMsal();
    const classes = useStyles();
    const [imageUrl, setImageUrl] = useState<string | null>(null);

    const graphClient = useMemo(() => GraphClient.initWithMiddleware({
        authProvider: {
            getAccessToken: () => msal.getAccessToken('https://graph.microsoft.com/User.Read'),
        },
    }), [msal]);

    useEffect(() => {
        (async () => {
            let photo;

            try {
                photo = await graphClient.api('/me/photos/64x64/$value').get();
            } catch (e) {
                // User has no photo
                return;
            }

            setImageUrl(URL.createObjectURL(photo));
        })();
    }, [graphClient]);

    if (!imageUrl) {
        return (
            <Avatar className={classes.avatar}>{getInitials(account.name)}</Avatar>
        );
    }

    return (
        <Avatar className={classes.avatar} alt={getInitials(account.name)} src={imageUrl}/>
    );
};

const getInitials = (name : string | undefined) : string | undefined => {
    if (!name) {
        return undefined;
    }

    const names = name.trim().split(' ');
    const firstName = names.shift();
    const lastName = names.pop();

    if (!firstName) {
        return undefined;
    }

    if (!lastName) {
        return firstName[0].toLocaleUpperCase();
    }

    return `${firstName[0].toLocaleUpperCase()}${lastName[0].toLocaleUpperCase()}`;
};

export default UserAvatar;
